<script setup>
import { ref, computed, watchEffect, onMounted } from "vue";
import PageHead from "@/components/PageHead/PageHead.vue";
import Width from "@/pages/Index/Width.vue";
import ListBlock from "@/components/ListBlock/ListBlock.vue";
import {extractText, useWindowResize} from "@/utils";
import axios from "axios";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {pageBg} from "@/constant";

const store = useStore()
const router = useRouter()

const { handleWindowResizeWithDebounce, windowSize } = useWindowResize()

const customerCaseList = ref([])
const gridOptions = ref({
	columns: 3,
	rowGap: 30,
	columnGap: 30
})

const currentLang = computed(() => store.getters.currentLanguage)

const imageList = computed(() => customerCaseList.value?.map(item => item?.image))

const getCustomerCase = async () => {
	const res = await axios.get('api/api/strength')
		.catch(err => {
			throw new Error(err.message)
		})
	console.log('res --------->', res)
	customerCaseList.value = res.data
}


const handleToDetails = (id) => {
	router.push({
		path: `/customer-case/${id}`
	})
}


watchEffect(() => {
	const n = windowSize.value
	if (n <= 535) {
		gridOptions.value.columns = 1
		gridOptions.value.columnGap = 20
		gridOptions.value.rowGap = 20
	} else if (n <= 1024) {
		gridOptions.value.columns = 2
		gridOptions.value.columnGap = 20
		gridOptions.value.rowGap = 20
	} else {
		gridOptions.value.columns = 3
		gridOptions.value.columnGap = 30
		gridOptions.value.rowGap = 30
	}
})

onMounted(() => {
	window.addEventListener('resize', handleWindowResizeWithDebounce)
	getCustomerCase()
})
</script>

<template>
	<div class="customer-case">
		<PageHead
			:bg-image="pageBg.customerCase"
			:title="$t('header.CustomerCase')"
		/>
		
		<Width>
			<div class="customer-case__content">
				<ListBlock
					:columns="gridOptions.columns"
					:column-gap="gridOptions.columnGap"
					:row-gap="gridOptions.rowGap"
				>
					<div
						class="customer-case__content__list"
						v-for="(item, index) in customerCaseList"
						:key="index"
						@click="handleToDetails(item.id)"
					>
						<div class="cover">
							<el-image
								:src="item.image"
								:initial-index="index"
								style="width: 100%; height: 100%;"
								fit="cover"
							/>
							
							<div class="mask">
<!--								<SvgIcon name="logo" class-name="mask__icon" />-->
								<img :src="item?.left_top_image" class="mask__icon" style="object-fit: contain;" />
							</div>
						</div>
						
						<div class="info">
							<div
								class="info__title line-clamp-1"
								
							>
								{{ item?.[`title_${currentLang}`] ?? item?.title_cn }}
							</div>
							
							<div class="info__desc line-clamp-3">
								{{ extractText(item?.[`content_${currentLang}`] ?? item?.content_cn) }}
							</div>
						</div>
						
						
					</div>
				</ListBlock>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.customer-case {
	background-color: #F5F5F5;
	&__content {
		padding: 72px 0;
		
		&__list {
			border-radius: 16px;
			overflow: hidden;
			background-color: #fff;
			
			.cover {
				background-color: #fff;
				height: 285px;
				position: relative;
				
				.mask {
					position: absolute;
					bottom: 0;
					width: 100%;
					padding: 20px 30px;
					background: linear-gradient(280deg, rgba(209, 23, 14, 0.8) 3%, rgba(244, 103, 96, 0.8) 100%);
					backdrop-filter: blur(10px);
					
					&__icon {
						height: 30px;
						width: 93px;
					}
				}
			}
			
			.info {
				padding: 30px;
				background-color: #fff;
				color: #303133;
				
				&__title {
					cursor: pointer;
					font-size: 24px;
					font-weight: bold;
				}
				
				&__desc {
					margin-top: 20px;
					font-size: 18px;
					line-height: 30px;
				}
			}
		}
	}
	
}

@media only screen and (max-width: 1024px) {
	.customer-case {
		&__content {
			padding: 30px 0;
			
			&__list {
				border-radius: 8px;
			}
		}
		
	}
}

@media only screen and (max-width: 768px) {
	.customer-case {
		
		&__content {
			
			&__list {
				border-radius: 8px;
				.cover {
					height: 210px;
					.mask {
						padding: 16px 20px;
						
						&__icon {
							height: 30px;
							width: 93px;
						}
					}
				}
				
				.info {
					padding: 20px;
					
					&__title {
						font-size: 18px;
					}
					
					&__desc {
						margin-top: 8px;
						font-size: 16px;
						line-height: 24px;
					}
				}
			}
			
		}
	}
}
</style>